/**
 * Created by Qingger Corp.
 * User: LL
 * Date: 2020.06.24
 * Time: 14:16
 * Desc: 促销活动
 */

import { Component, Vue } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';
import { appEnvConfig } from '@/configs/appConfigs';
import { Functions } from '@/library/utils/functions';
import NoAuth from '@/views/components/noAuth/noAuth.vue';
import { noop, parseSec } from '@/util';
import NewSelectSite from '@/views/components/newSelectSIte';

@Component({
  components: {
    NoAuth,
  },
})
export default class PromotionActivity extends Vue {
  // loading状态
  public loadingState = true;

  // 列表总数
  public total = 0;

  // 搜索关键字
  public keyword = '';

  // 页码
  public page = 1;

  // 每页显示数量
  public pageNum = 10;

  // 是否显示
  public isContentBodyShow = false;

  // 促销活动列表

  public promotionList: Array<ItemObject> = [];

  // 列表选中项
  public tableSelected: any[] = [];

  // 活动状态  0全部显示、4已下架、5未开始、2进行中、1已过期、5未开始&进行中&上架状态
  public status = 0;

  // 网点编号
  public siteCodes: Array<string> = [];

  public date = [];

  public defaultStart: Date | number;

  public defaultEnd: Date | number;

  // 活动状态
  public activityStatus: Array<ItemObject> = [
    {
      value: 0,
      label: '全部',
    },
    {
      value: 4,
      label: '已下架',
    },
    {
      value: 3,
      label: '未开始',
    },
    {
      value: 2,
      label: '进行中',
    },
    {
      value: 1,
      label: '已过期',
    },
  ];

  //  方法开始

  public created() {
    this.defaultStart = parseSec(3);
    this.defaultEnd = parseSec(4);
    this.date = [this.defaultStart, this.defaultEnd];
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-MARKETING-CENTER-OMS-ACTIVITY');
    this.getPromotionActivity();
  }

  /**
   * 搜索促销活动方法
   * @returns {null}
   */
  public onSearchPromotionActivity() {
    this.page = 1;
    this.pageNum = 10;
    this.getPromotionActivity();
  }

  public dateChange() {
    this.page = 1;
    this.getPromotionActivity();
  }

  /**
   * 获取促销活动列表
   * @returns {null}
   */
  public getPromotionActivity() {
    const postParams = {
      keyword: this.keyword,
      status: this.status,
      siteCodes: this.siteCodes,
      page: this.page,
      pageNum: this.pageNum,
    };
    if (this.date && this.date.length) {
      (postParams['startOfTime'] = parseSec(1, this.date[0])), (postParams['endOfTime'] = parseSec(2, this.date[1]));
      if (this.date[1] - this.date[0] > 184 * 24 * 3600 * 1000) {
        this.$message.error('更新时间跨度不能超过6个月！');
        this.date = [this.defaultStart, this.defaultEnd];
        (postParams['startOfTime'] = parseSec(1, this.date[0])), (postParams['endOfTime'] = parseSec(2, this.date[1]));
        this.ipsGetList(postParams);
        return;
      }
    }
    this.ipsGetList(postParams);
  }

  ipsGetList(postParams) {
    const that = this;
    IPSService.getPromotionList({
      postParams,
    })
      .then((response) => {
        that.loadingState = false;
        that.total = response.count;
        response.list.forEach((element) => {
          element = Object.assign(
            element,
            {
              activityDate: `${Functions.timeFormatSec(element.startTime)}~${Functions.timeFormatSec(element.endTime)}`,
            },
            {
              updateTimeStr: Functions.timeFormatSec(element.updateTime, true),
              beforeBeginTime: Functions.timeFormatSec(element.beforeBeginTime),
            },
            {
              startTimeStr: Functions.timeFormatSec(element.startTime),
              endTimeStr: Functions.timeFormatSec(element.endTime),
            },
          );
        });
        that.promotionList = response.list;
      })
      .catch((error) => {
        that.loadingState = false;
        console.log(error);
      });
  }

  // 列表选中事件
  onHandleSelectionChange(selected: any[]) {
    this.tableSelected = selected;
  }

  /**
   * 切换显示数量事件
   * @param {number} val
   * @returns null
   */
  public onHandleSizeChange(val) {
    this.pageNum = val;
    this.getPromotionActivity();
  }

  /**
   * 切换页码事件
   * @param {number} val
   * @returns null
   */
  public onHandleCurrentChange(val) {
    this.page = val;
    this.getPromotionActivity();
  }

  /**
   * 编辑促销活动
   * @param {} val
   */
  public editPromotionActivity(val) {
    this.$router.push({
      path: '/promotionEdit',
      query: {
        id: val,
        flag: '0',
      },
    });
  }

  /**
   * 查看促销活动
   * @param {} val
   */
  public viewPromotionActivity(val) {
    this.$router.push({
      path: '/promotionEdit',
      query: {
        id: val,
        flag: '1',
      },
    });
  }

  /**
   * 删除促销活动
   * @param {} val
   */
  public delPromotionActivity(val) {
    this.$confirm('确认删除?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      type: 'warning',
    }).then((res) => {
      if (res == 'confirm') {
        IPSService.delPromotion({
          postParams: {
            state: -1,
            opId: val,
          },
        }).then((response) => {
          if (response.result) {
            this.$message.success('删除成功');
            this.page = 1;
            this.pageNum = 10;
            this.getPromotionActivity();
          } else {
            this.$message.success('删除失败');
          }
        });
      }
    });
  }

  /**
   * 下架促销活动
   * @param {} val
   */
  public downPromotionActivity(val) {
    this.$confirm('下架仅控制小程序不在活动模块中和广告中展示该活动，不影响商品参与活动，是否确认下架？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then((res) => {
      if (res == 'confirm') {
        IPSService.promotionStateEdit({
          postParams: {
            opId: val,
            state: 0,
          },
        }).then((response) => {
          if (response.result) {
            this.$message.success('下架成功');
            this.getPromotionActivity();
          } else {
            this.$message.success('下架失败');
          }
        });
      }
    });
  }

  /**
   * 当前选择的活动状态
   */
  selectStatus(value) {
    this.status = value;
    this.page = 1;
    this.getPromotionActivity();
  }

  /**
   * 创建促销活动
   * @returns {null}
   */
  public createPromotion() {
    this.$router.push({
      path: '/promotionEdit',
      query: {
        flag: '0',
      },
    });
  }

  /**
   * 查看网点
   */
  public onSiteListShow(siteCodes) {
    new NewSelectSite().open({
      service: 'authTree',
      selectCodes: siteCodes,
      readonly: true,
    }).then(noop, noop);
  }

  /**
   * 清除数据
   */
  public clearData() {
    this.keyword = '';
    this.page = 1;
    this.pageNum = 10;
    this.status = 0;
  }

  /**
   * 上架
   */
  public upPromotionActivity(val) {
    this.$confirm('是否上架该促销活动?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then((res) => {
      if (res == 'confirm') {
        IPSService.promotionStateEdit({
          postParams: {
            opId: val,
            state: 1,
          },
        }).then((response) => {
          if (response.result) {
            this.$message.success('上架成功');
            this.getPromotionActivity();
          } else {
            this.$message.success('上架失败');
          }
        });
      }
    });
  }

  /**
   * 同步时间
   */
  public syncTime(opId, proCode) {
    this.$confirm('如DRP活动发生变更，将同步更新活动信息', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then((res) => {
      if (res == 'confirm') {
        IPSService.syncOmsTime({ postParams: { opId, proCode } }).then(
          () => {
            this.$message.success('同步成功');
            this.getPromotionActivity();
          },
          () => {},
        );
      }
    });
  }
}
